import React from 'react';
import './GoverningLawAndJurisdiction.css'; // Link to CSS for styling
import NavBar from '../NavBar/NavBar';
import RunningHeader from '../RunningHeader/RunningHeader';
import Footer from '../Footer/Footer';

const GoverningLawAndJurisdiction = () => {
  return (
    <div>
      <NavBar/>
      <RunningHeader/>
    <div className="governing-law-container">
      <h1>Governing Law and Jurisdiction</h1>
      <section>
        <h2>Governing Law</h2>
        <p>
          This Agreement shall be governed by and construed in accordance with the laws of <strong>India/Tamil Nadu</strong>.
        </p>
      </section>
      <section>
        <h2>Jurisdiction</h2>
        <p>
          Any disputes arising from this Agreement shall be subject to the jurisdiction of the courts of <strong>India/Tamil Nadu</strong>.
        </p>
      </section>
      <section>
        <h2>Changes to Terms</h2>
        <p>
          TLN reserves the right to modify or update these Terms at any time, without notice or liability.
        </p>
      </section>
      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions or concerns about these Terms, please contact us at <a href="mailto:contact@example.com">contact@example.com</a> or visit us at <strong>Contact Address</strong>.
        </p>
      </section>
    </div>
    <Footer/>
    </div>
  );
};

export default GoverningLawAndJurisdiction;
